import { useQuery } from '@tanstack/react-query';
import { getSupabaseUrl, getAnonKey, getEdgeFunctionUrl } from '@/utils/supabaseUrl';

export interface PublicApprover {
  id: string;
  approval_level: number | null;
  max_approval_amount: number | null;
  first_name: string;
  last_name: string;
  full_name: string;
}

export const usePublicApprovers = (departmentId: string | null) => {
  return useQuery({
    queryKey: ['public-approvers', departmentId],
    queryFn: async () => {
      if (!departmentId) return [];

      const response = await fetch(
        `${getEdgeFunctionUrl('public-payment-data')}?type=approvers&department_id=${departmentId}`,
        {
          headers: {
            'apikey': getAnonKey(),
            'Content-Type': 'application/json',
          },
        }
      );

      if (!response.ok) {
        throw new Error('Failed to fetch approvers');
      }

      const result = await response.json();
      return result.approvers as PublicApprover[];
    },
    enabled: !!departmentId,
  });
};
